//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../Drawings/Drawings.HalfSectionLineBuilder.js";
import "../Drawings/Drawings.OrientedSectionLineBuilder.js";
import "../Drawings/Drawings.ParentViewBuilder.js";
import "../Drawings/Drawings.SteppedSectionLineBuilder.js";
import "../Drawings/Drawings.PointAndAngleSectionLineBuilder.js";
import "../Drawings/Drawings.PointToPointSectionLineBuilder.js";
import "../Drawings/Drawings.RevolvedSectionLineBuilder.js";
import "../Drawings/Drawings.SectionLineStyleBuilder.js";
let d=[[[0,"ArrowDirection",1,"Direction",1],[0,"CutDirection",1,"Direction",1],[1,"Half",0,"Drawings.HalfSectionLineBuilder",1],[1,"HalfPictorial",0,"Drawings.HalfSectionLineBuilder",1],[0,"HingeDirection",1,"Direction",1],[1,"Oriented",0,"Drawings.OrientedSectionLineBuilder",1],[1,"ParentView",0,"Drawings.ParentViewBuilder",1],[1,"Pictorial",0,"Drawings.SteppedSectionLineBuilder",1],[1,"PointAndAngle",0,"Drawings.PointAndAngleSectionLineBuilder",1],[1,"PointToPoint",0,"Drawings.PointToPointSectionLineBuilder",1],[1,"Revolved",0,"Drawings.RevolvedSectionLineBuilder",1],[1,"SimpleOrStepped",0,"Drawings.SteppedSectionLineBuilder",1],[1,"Style",0,"Drawings.SectionLineStyleBuilder",1],[0,"Type",1,1]],[],[]];
SPLM.Drawings.SectionLineBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.SectionLineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.SectionLineBuilder.Types = Object.freeze({
    "SimpleOrStepped" : "SimpleOrStepped", "Half" : "Half", "Revolved" : "Revolved", "PointToPoint" : "PointToPoint", "PointAndAngle" : "PointAndAngle", "Pictorial" : "Pictorial", "HalfPictorial" : "HalfPictorial", "Oriented" : "Oriented"});

export default SPLM;